import { Injectable } from "@angular/core";
import { PackagingPart } from "src/app/model/packaging-part-enum";

export enum RelevantAnalysisType {
  Recyclability,
  Lifecycle,
  CostCalculation
}
export class RelevantAnalysisTypes {
  public recyclingRelevant: boolean = false;
  public lcaRelevant: boolean = false;
  public ccRelevant: boolean = false;

  constructor(recyclingRelevant: boolean , lcaRelevant: boolean, ccRelevant: boolean ) {
    this.recyclingRelevant = recyclingRelevant;
    this.lcaRelevant = lcaRelevant;
    this.ccRelevant = ccRelevant;
  }

  public equals (relevantAnalysisTypes: RelevantAnalysisTypes) : boolean {
    return this.recyclingRelevant === relevantAnalysisTypes.recyclingRelevant &&
           this.lcaRelevant === relevantAnalysisTypes.lcaRelevant &&
           this.ccRelevant === relevantAnalysisTypes.ccRelevant;
  }
}
class RelevantField {
  public fieldName: string;
  public relevantTypes: RelevantAnalysisTypes;
  constructor(fieldName: string, relevantTypes: RelevantAnalysisTypes) {
    this.fieldName = fieldName;
    this.relevantTypes = relevantTypes;
  }
}

@Injectable({ providedIn: 'root' })
export class RelevantAnalysisService {
  relevantSystemFields : RelevantField[] = [
    new RelevantField("distributionLocations",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("assemblyLocation",new RelevantAnalysisTypes(false,true,false)),
  ];
  relevantUnitFields : RelevantField[] = [
    new RelevantField("distributionLocations",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("length",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("width",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("height",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("assemblyLocation",new RelevantAnalysisTypes(false,true,false)),
  ];
  relevantComponentFields : RelevantField[] = [
    new RelevantField("packagingComponentSubtype",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("manufacturingLocation",new RelevantAnalysisTypes(false,true,false)),
    new RelevantField("length",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("width",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("height",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("isPhysicallyAttached",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("removabilityCondition",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("isAdhesiveUsed",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("separationThroughCollectionAndSorting",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("removedByConsumer",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("removedBeforeUsage",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("containsNearInfraredBarrier",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("isRigidComponent",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("printingCoverage",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("surfaceRatio",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("manufacturingLocation",new RelevantAnalysisTypes(false,true,false)),
  ];
  relevantMaterialFields : RelevantField[] = [
    new RelevantField("function",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("material",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("materialManifestation",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("mass",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("color",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("manufacturingType",new RelevantAnalysisTypes(false,true,false)),
    new RelevantField("density",new RelevantAnalysisTypes(true,true,true)),
    new RelevantField("recyclingMaterialPercentage",new RelevantAnalysisTypes(false,true,true)),
    new RelevantField("materialOrigin",new RelevantAnalysisTypes(false,true,false)),
  ];
  isFieldRelevantForCalculations(relevantTypes: RelevantAnalysisTypes, packagingPart: PackagingPart, fieldName : string) : boolean {
    switch(packagingPart) {
      case PackagingPart.System:
        return this.isRelevantSystemField(relevantTypes,fieldName);
      case PackagingPart.Unit:
        return this.isRelevantUnitField(relevantTypes,fieldName);
      case PackagingPart.Component:
        return this.isRelevantComponentField(relevantTypes,fieldName);
      case PackagingPart.Material:
        return this.isRelevantMaterialField(relevantTypes,fieldName);
      default :
        return false;
    }
  }

  private isRelevantSystemField(relevantTypes: RelevantAnalysisTypes, fieldName : string) : boolean {
    return this.isRelevantField(relevantTypes,fieldName,this.relevantSystemFields);
  }

  private isRelevantUnitField(relevantTypes: RelevantAnalysisTypes, fieldName : string) : boolean {
    return this.isRelevantField(relevantTypes,fieldName,this.relevantUnitFields);
  }

  private isRelevantComponentField(relevantTypes: RelevantAnalysisTypes, fieldName : string) : boolean {
    return this.isRelevantField(relevantTypes,fieldName,this.relevantComponentFields);
  }

  private isRelevantMaterialField(relevantTypes: RelevantAnalysisTypes, fieldName : string) : boolean {
    return this.isRelevantField(relevantTypes,fieldName,this.relevantMaterialFields);
  }

  private haveMatchingTypes(relevantTypes: RelevantAnalysisTypes,usedTypes: RelevantAnalysisTypes) : boolean {
    return (relevantTypes.ccRelevant && usedTypes.ccRelevant) ||
           (relevantTypes.lcaRelevant && usedTypes.lcaRelevant) ||
           (relevantTypes.recyclingRelevant && usedTypes.recyclingRelevant);
  }

  private isRelevantField(relevantTypes: RelevantAnalysisTypes, fieldName : string, packagingPartFields: RelevantField[]): boolean {
    for ( const relevantField of packagingPartFields) {
        if(relevantField.fieldName == fieldName) {
          return this.haveMatchingTypes(relevantField.relevantTypes,relevantTypes);
        }
    }
    return false;
  }

}
